/** Matches affiliate promo codes: PREFIX-XXXXXX (6 alphanumeric suffix). */
const PREFIXED_PROMO_CODE_PATTERN = /^([A-Z0-9]+)-([A-Z0-9]{6})$/;

export function parsePrefixedPromoCode(code: string): string | null {
  const match = PREFIXED_PROMO_CODE_PATTERN.exec(code.toUpperCase());
  return match ? match[1] : null;
}
